export enum DashboardWidgetType {
  BIDS_REMAINING = 'bids_remaining',
  GROUPS = 'groups',
  LOCAL_JOBS = 'local_jobs',
  MY_PROFILE = 'my_profile',
  NEXT_PROJECT_RECOMMENDATIONS = 'next_project_recommendations',
  PF_SUPPORT = 'pf_support',
  POLLS = 'polls',
  ZERO_COMMISSION = 'zero_commission',
  ONBOARDING_VIDEO = 'onboarding_video',
  CREDIT_TERMS = 'credit_terms',
  USER_AVAILABILITY = 'user_availability',
  GIVE_GET = 'give_get',
  RETENTION_SCORE = 'retention_score',
  ASSET_FINANCE_SHOP = 'asset_finance_shop',
}

/**
 * A widget displayed on the dashboard (https://www.freelancer.com/dashboard).
 * Each card or panel is one widget, and each user sees different widgets.
 */
export interface DashboardWidget {
  readonly id: DashboardWidgetType;
  readonly order: number;
}
